// src/services/mockData.js
// This file provides a mock data service for testing with real competition data

// Import the sample data (replace this with your actual JSON data)
const sampleCompetitionData = {
    "Competition": {
        "ID": 3161908,
        "Name": "Sharks Open 2024 Presentert Av TIGA &rarr; Round 1",
        "Type": "2",
        "Date": "2024-10-26",
        "Time": "10:00:00",
        "Comment": "",
        "CourseName": "Lømyra Diskgolf park &rarr; Lømyra Blå 18-Hulls",
        "CourseID": "33022",
        "Results": [
            {
                "UserID": "41996",
                "ScorecardID": "12370820",
                "Name": "Kristian Rørstad",
                "ClassName": "Pro Open",
                "CountryCode": "NO",
                "Group": "8",
                "PlayerResults": [
                    {
                        "Result": "4",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 0,
                        "OB": "1"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 0,
                        "OB": "0"
                    }
                ],
                "Penalty": null,
                "Sum": 52,
                "Diff": -6,
                "DNF": null,
                "PreviousRoundsSum": null,
                "PreviousRoundsDiff": null,
                "Place": 1,
                "OrderNumber": 1
            },
            {
                "UserID": "20658",
                "ScorecardID": "12370832",
                "Name": "Knut Håland",
                "ClassName": "Pro Open",
                "CountryCode": "NO",
                "Group": "17",
                "PlayerResults": [
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "1"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "1"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    }
                ],
                "Penalty": null,
                "Sum": 52,
                "Diff": -6,
                "DNF": null,
                "PreviousRoundsSum": null,
                "PreviousRoundsDiff": null,
                "Place": 1,
                "OrderNumber": 1
            },
            {
                "UserID": "166627",
                "ScorecardID": "12370825",
                "Name": "Mats Andersen",
                "ClassName": "Pro Open",
                "CountryCode": "NO",
                "Group": "3",
                "PlayerResults": [
                    {
                        "Result": "4",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "1"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "1"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "1"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    }
                ],
                "Penalty": null,
                "Sum": 55,
                "Diff": -3,
                "DNF": null,
                "PreviousRoundsSum": null,
                "PreviousRoundsDiff": null,
                "Place": 3,
                "OrderNumber": 3
            },
            {
                "UserID": "35665",
                "ScorecardID": "12370809",
                "Name": "Frank Tangen",
                "ClassName": "Pro Open",
                "CountryCode": "NO",
                "Group": "13",
                "PlayerResults": [
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "5",
                        "Diff": 1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "5",
                        "Diff": 2,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    }
                ],
                "Penalty": null,
                "Sum": 55,
                "Diff": -3,
                "DNF": null,
                "PreviousRoundsSum": null,
                "PreviousRoundsDiff": null,
                "Place": 3,
                "OrderNumber": 3
            },
            {
                "UserID": "49221",
                "ScorecardID": "12370810",
                "Name": "Mikael Ahlberg",
                "ClassName": "Pro Open",
                "CountryCode": "NO",
                "Group": "5",
                "PlayerResults": [
                    {
                        "Result": "4",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "1"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    }
                ],
                "Penalty": null,
                "Sum": 56,
                "Diff": -2,
                "DNF": null,
                "PreviousRoundsSum": null,
                "PreviousRoundsDiff": null,
                "Place": 5,
                "OrderNumber": 5
            },
            {
                "UserID": "75802",
                "ScorecardID": "12370837",
                "Name": "Joakim Ekornåsvåg",
                "ClassName": "Pro Open",
                "CountryCode": "NO",
                "Group": "5",
                "PlayerResults": [
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "5",
                        "Diff": 1,
                        "OB": "1"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "6",
                        "Diff": 3,
                        "OB": "1"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "1"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    }
                ],
                "Penalty": null,
                "Sum": 56,
                "Diff": -2,
                "DNF": null,
                "PreviousRoundsSum": null,
                "PreviousRoundsDiff": null,
                "Place": 5,
                "OrderNumber": 5
            },
            {
                "UserID": "130032",
                "ScorecardID": "12370812",
                "Name": "Brede Jensen",
                "ClassName": "Pro Open",
                "CountryCode": "NO",
                "Group": "17",
                "PlayerResults": [
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "1"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "5",
                        "Diff": 2,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "1"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 0,
                        "OB": "0"
                    }
                ],
                "Penalty": null,
                "Sum": 58,
                "Diff": 0,
                "DNF": null,
                "PreviousRoundsSum": null,
                "PreviousRoundsDiff": null,
                "Place": 7,
                "OrderNumber": 7
            },
            {
                "UserID": "159940",
                "ScorecardID": "12370807",
                "Name": "Kenneth Jensen",
                "ClassName": "Pro Open",
                "CountryCode": "NO",
                "Group": "1",
                "PlayerResults": [
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 0,
                        "OB": "1"
                    },
                    {
                        "Result": "5",
                        "Diff": 2,
                        "OB": "1"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "5",
                        "Diff": 2,
                        "OB": "1"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "1"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "1"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    }
                ],
                "Penalty": null,
                "Sum": 59,
                "Diff": 1,
                "DNF": null,
                "PreviousRoundsSum": null,
                "PreviousRoundsDiff": null,
                "Place": 8,
                "OrderNumber": 8
            },
            {
                "UserID": "29826",
                "ScorecardID": "12370815",
                "Name": "Tor Magne Blomvik",
                "ClassName": "Pro Open",
                "CountryCode": "NO",
                "Group": "10",
                "PlayerResults": [
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 0,
                        "OB": "1"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "1"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "1"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "1"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "0"
                    },
                    {
                        "Result": "5",
                        "Diff": 2,
                        "OB": "1"
                    },
                    {
                        "Result": "4",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    }
                ],
                "Penalty": null,
                "Sum": 62,
                "Diff": 4,
                "DNF": null,
                "PreviousRoundsSum": null,
                "PreviousRoundsDiff": null,
                "Place": 9,
                "OrderNumber": 9
            },
            {
                "UserID": "22925",
                "ScorecardID": "12370811",
                "Name": "Dan Kråkenes",
                "ClassName": "Pro Open",
                "CountryCode": "NO",
                "Group": "3",
                "PlayerResults": [
                    {
                        "Result": "4",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 0,
                        "OB": "1"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "1"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "5",
                        "Diff": 2,
                        "OB": "1"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "6",
                        "Diff": 3,
                        "OB": "1"
                    },
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    }
                ],
                "Penalty": null,
                "Sum": 63,
                "Diff": 5,
                "DNF": null,
                "PreviousRoundsSum": null,
                "PreviousRoundsDiff": null,
                "Place": 10,
                "OrderNumber": 10
            },
            {
                "UserID": "121234",
                "ScorecardID": "12370808",
                "Name": "Vegard Bardalen",
                "ClassName": "Pro Open",
                "CountryCode": "NO",
                "Group": "3",
                "PlayerResults": [
                    {
                        "Result": "4",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 0,
                        "OB": "1"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "6",
                        "Diff": 3,
                        "OB": "1"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "0"
                    },
                    {
                        "Result": "2",
                        "Diff": -1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "5",
                        "Diff": 2,
                        "OB": "0"
                    },
                    {
                        "Result": "5",
                        "Diff": 1,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "1"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": 0,
                        "OB": "0"
                    },
                    {
                        "Result": "4",
                        "Diff": 1,
                        "OB": "0"
                    },
                    {
                        "Result": "3",
                        "Diff": -1,
                        "OB": "0"
                    }
                ],
                "Penalty": null,
                "Sum": 65,
                "Diff": 7,
                "DNF": null,
                "PreviousRoundsSum": null,
                "PreviousRoundsDiff": null,
                "Place": 11,
                "OrderNumber": 11
            }
        ],
        "Tracks": [
            {"Number": "1", "NumberAlt": "", "Par": "4"},
            {"Number": "2", "NumberAlt": "", "Par": "4"},
            {"Number": "3", "NumberAlt": "", "Par": "3"},
            {"Number": "4", "NumberAlt": "", "Par": "3"},
            {"Number": "5", "NumberAlt": "", "Par": "3"},
            {"Number": "6", "NumberAlt": "", "Par": "3"},
            {"Number": "7", "NumberAlt": "", "Par": "3"},
            {"Number": "8", "NumberAlt": "", "Par": "3"},
            {"Number": "9", "NumberAlt": "", "Par": "3"},
            {"Number": "10", "NumberAlt": "", "Par": "3"},
            {"Number": "11", "NumberAlt": "", "Par": "3"},
            {"Number": "12", "NumberAlt": "", "Par": "4"},
            {"Number": "13", "NumberAlt": "", "Par": "3"},
            {"Number": "14", "NumberAlt": "", "Par": "3"},
            {"Number": "15", "NumberAlt": "", "Par": "3"},
            {"Number": "16", "NumberAlt": "", "Par": "3"},
            {"Number": "17", "NumberAlt": "", "Par": "3"},
            {"Number": "18", "NumberAlt": "", "Par": "4"}
        ]
    },
    "Errors": []
};

// Function to get mock data - can be used as a replacement for API calls during development
export const getMockCompetitionData = async () => {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 300));

    // Return the mock data
    return sampleCompetitionData;
};

// Export the raw data for direct use if needed
export const rawCompetitionData = sampleCompetitionData;
